const columns = ['name', 'zones', 'actions']
export const [COLUMN_NAME, COLUMN_ZONES, COLUMN_ACTIONS] = columns

export const gridColumns = [
  {
    key: COLUMN_NAME,
    size: 2,
    minWidth: 100,
  },
  {
    key: COLUMN_ZONES,
    size: 2,
    minWidth: 200,
  },
  {
    key: COLUMN_ACTIONS,
    size: 2,
    minWidth: 100,
  },
]
